import React, { useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Text,
  Box,
  Button,
  Select
} from '@chakra-ui/react';
import { CategoryType } from '../Table/MaintenanceCategoryTable';
import { CreateCategoriesApi } from '../../../../apis/CreateMaintenance.api';
import {
  CustomStringInput,
  BanInputType
} from '../../../atoms/CustomStringInput';
import { CategorySendMessageType } from '../../../constants/MaintenanceConstants';

interface ResponseType {
  success: boolean;
  data: CategoryType[] | null;
  message: unknown | null;
}

interface props {
  isOpen: boolean;
  onClose: () => void;
  setMaintenanceDatas: React.Dispatch<
    React.SetStateAction<CategoryType[] | undefined>
  >;
  CreateOrUpdateStateSwitch: () => void;
}

const GetCategoryNameInputCheckData = (addData: string | undefined) => {
  if (addData === undefined) {
    return { Length: 300, BanInputType: BanInputType.None, Value: '' };
  }
  return { Length: 300, BanInputType: BanInputType.None, Value: addData };
};

const CategoryCreateWindow: React.FC<props> = (props) => {
  const { isOpen, onClose, setMaintenanceDatas, CreateOrUpdateStateSwitch } =
    props;
  const [categoryName, setCategoryName] = useState<string | undefined>('');
  const [type, setType] = useState(CategorySendMessageType.Signage);

  const CreateApi = async () => {
    const response: ResponseType = await CreateCategoriesApi({
      name: categoryName,
      type: type
    });
    if (response.success === false) {
      alert('登録に失敗しました。');
      return;
    }
    setMaintenanceDatas(response.data as CategoryType[]);
    CreateOrUpdateStateSwitch();
    onClose();
  };
  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent h='280px' maxW='1100px'>
          <ModalHeader
            textAlign='center'
            bg='gray.800'
            color='white'
            fontSize='16'
          >
            カテゴリ作成
          </ModalHeader>
          <ModalCloseButton color='white' />
          <ModalBody>
            <Box
              position='relative'
              display='grid'
              gridTemplateColumns='1fr 6fr'
            >
              <Text mt={4}>カテゴリ名</Text>
              <CustomStringInput
                CheckInfo={GetCategoryNameInputCheckData('')}
                inputValue={categoryName}
                setValue={setCategoryName}
                PhohibitionCharaCheck={false}
              />

              <Text mt={4}>タイプ</Text>
              <Select
                mt={2}
                w='30%'
                value={type}
                onChange={(e) => {
                  setType(e.target.value);
                }}
              >
                <option value={CategorySendMessageType.Signage}>
                  停留場メッセージ
                </option>
                <option value={CategorySendMessageType.Obc}>
                  OBCメッセージ
                </option>
                <option value={CategorySendMessageType.Location}>
                  位置情報メッセージ
                </option>
                <option value={CategorySendMessageType.Message}>
                  共通メッセージ
                </option>
              </Select>
            </Box>
            <Button
              mt={10}
              onClick={() => {
                CreateApi();
              }}
            >
              作成
            </Button>
            <Button mt={10} ml={10} onClick={() => onClose()}>
              取り消す
            </Button>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default React.memo(CategoryCreateWindow);
